import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PrimitiveTypes } from '@angular/cli/src/analytics/analytics-parameters';

export enum TextareaStyle {
  Primary = 'primary',
  Secondary = 'secondary'
}

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextareaComponent implements ControlValueAccessor {
  label: InputSignal<string> = input<string>('');
  placeholder: InputSignal<string> = input<string>('');

  // Size
  resizable: InputSignal<boolean> = input<boolean>(false);
  rows: InputSignal<number> = input<number>(4);
  minWidth: InputSignal<string> = input<string>('100%');
  maxWidth: InputSignal<string> = input<string>('100%');

  // Style
  style: InputSignal<TextareaStyle> = input<TextareaStyle>(
    TextareaStyle.Primary
  );

  // State
  value: WritableSignal<PrimitiveTypes> = signal<PrimitiveTypes>('');
  isDisabled: WritableSignal<boolean> = signal<boolean>(false);

  onValueChange(event: Event) {
    const eventTarget: HTMLTextAreaElement =
      event.target as HTMLTextAreaElement;

    this.value.set(eventTarget.value);
    this.onChange(eventTarget.value);
    this.onTouched();
  }

  // ControlValueAccessor
  private onChange = (value: PrimitiveTypes) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  writeValue(outsideValue: PrimitiveTypes): void {
    this.value.set(outsideValue);
  }
}
